// Login Methods Allowed
export interface ILoginMethodsAllowed {
  EmailOTP: boolean;
  MobileOTP: boolean;
  Gmail: boolean;
  GoogleRecaptcha: boolean;
}

// Client Info
export interface IClientInfo {
  ClientId: string | null;
  Scopes: string[] | null;
  LoginMethodsAllowed: ILoginMethodsAllowed;
  CountryCode: string | null;
}
export interface IClientInfoResponse {
  Value: IClientInfo
}

// Apple User Info
export interface IAppleUserInfo {
  name: {
    firstName: string | null;
    lastName: string | null;
  };
  email: string | null;
}
// Temp Token
export interface ITempTokenRequestBody {
  AuthCode: string;
  RedirectUri: string;
  AppleUser?: IAppleUserInfo | null;
}

export interface ITempToken {
  Token: string,
  ExpiresIn: number
}
export interface ITempTokenResponse {
  Value: ITempToken
}

// Login Success
export interface ILoginSuccessInfo {
  AccessToken: string,
  RefreshToken: string,
  Expiry: string
}



// Verify OTP
export interface IVerifyOTPRequestBody {
  VerificationToken: string
  UserInput: string
  Receiver: string
}
export interface IVerifyOTP {
  Token: string,
  ExpiresIn: number,
  VerifiedAt: string
}

export interface IVerifyOTPResponse {
  Value: IVerifyOTP,
  Receiver: string;
}
export interface IVerifyParentalOTPResponse {
  Value: {
    Verified: boolean
  },
}

// Generate OTP
export interface IGenerateOTPRequestBody {
  Receiver: string
  DeliveryMode: 'EMAIL' | 'SMS'
}

export interface IGenerateOTP {
  VerificationToken: string,
  ExpiresIn: number,
  Receiver: string
  DeliveryMode: 'EMAIL' | 'SMS'
}

export interface IGenerateOTPResponse {
  Value: IGenerateOTP
}

export enum AuthStatus {
  LoggedIn,
  Error,
  LoggedOut,
  UnRegisteredUser
}

export interface IVerifyRecaptchaRequest {
  RecaptchaUserToken: string;
}

export interface IVerifyRecaptchaResponse {
  Allow: boolean;
}